// extracted by mini-css-extract-plugin
var _1 = "#68914d";
var _2 = "#9cc681";
var _3 = "#8ab46f";
var _4 = "automatic-changes-proposed___bNB1b";
var _5 = "8px";
var _6 = "6px";
var _7 = "8px";
var _8 = "0 1px 1px 0 rgba(0,0,0,.02) inset";
var _9 = "0 8px 8px -4px rgba(0,0,0,.03),0 16px 24px -4px rgba(0,0,0,.08)";
var _a = "10px";
var _b = "#e8e8e8";
var _c = "16px 24px";
var _d = "#38aa73";
var _e = "#956c22";
var _f = "#2988bd";
var _10 = "#eee";
var _11 = "#c4842d";
var _12 = "#b8567c";
var _13 = "#8b6e4e";
var _14 = "#5889c2";
var _15 = "#4e8a8a";
var _16 = "#6a8a3e";
var _17 = "#7b5ea7";
var _18 = "#4a6fa5";
var _19 = "#3a8a6e";
var _1a = "#c25b4e";
var _1b = "#fafbfc";
var _1c = "#1e3050";
var _1d = "#293d62";
var _1e = "#fafbfc";
var _1f = "rgba(0,0,0,.12)";
var _20 = "#d9d9d9";
var _21 = "rgba(5,5,5,.1)";
var _22 = "#eaf2fc";
var _23 = "rgba(0,0,0,.65)";
var _24 = "#ebebeb";
var _25 = "#068467";
var _26 = "rgba(6,132,103,.1)";
var _27 = "#dc4949";
var _28 = "rgba(220,73,73,.1)";
var _29 = "#787c81";
var _2a = "#d6d9dc";
var _2b = "#f3f5f7";
var _2c = "#73c9b2";
var _2d = "linear-gradient(180deg, #73C9B2 0%, #B8E7DA 100%)";
var _2e = "#b8e7da";
var _2f = "#5357f8";
var _30 = "rgb(14.3921787709,19.9877094972,245.2078212291)";
var _31 = "rgb(249.6189944134,249.7441340782,254.7810055866)";
var _32 = "#f7f8f9";
var _33 = "#edeeef";
var _34 = "#7b8996";
var _35 = "#ededed";
var _36 = "#f4f5f7";
var _37 = "#fbfbfc";
var _38 = "rgba(0,0,0,.75)";
var _39 = "rgba(171.2567039106,172.4612273574,220.9432960894,.95)";
var _3a = "rgba(0,0,0,.3)";
var _3b = "rgba(0,0,0,.5)";
var _3c = "rgba(0,0,0,.4)";
var _3d = "rgba(0,0,0,.95)";
var _3e = "rgba(0,0,0,.65)";
var _3f = "rgba(0,0,0,.85)";
var _40 = "20px";
var _41 = "#f41e28";
var _42 = "1063px";
var _43 = "rgba(227,89,86,.2)";
var _44 = "#e35956";
var _45 = "failure___a6jf2";
var _46 = "16px 24px";
var _47 = "28px";
var _48 = "32px";
var _49 = "18px";
var _4a = "14px";
var _4b = "14px";
var _4c = "15px";
var _4d = "12.6px";
var _4e = "11px";
var _4f = "20px";
var _50 = "28px";
var _51 = "700";
var _52 = "200";
var _53 = "300";
var _54 = "500";
var _55 = "400";
var _56 = "600";
var _57 = "hsla(0,0%,100%,.2)";
var _58 = "#ccc";
var _59 = "49px";
var _5a = "icon___r59wa";
var _5b = "5px";
var _5c = "#5357f8";
var _5d = "rgba(0,0,0,.4)";
var _5e = "neutral___AUVKL";
var _5f = "#fafafa";
var _60 = "hsla(0,0%,100%,.9)";
var _61 = "15px";
var _62 = "20px";
var _63 = "24px";
var _64 = "hsla(0,0%,100%,.6)";
var _65 = "#7e7eff";
var _66 = "hsla(0,0%,100%,.7)";
var _67 = "hsla(0,0%,100%,.3)";
var _68 = "hsla(0,0%,100%,.575)";
var _69 = "60px";
var _6a = "208px";
var _6b = "state-wrapper___whi9M";
var _6c = "success___zXlQO";
var _6d = "rgba(82,196,26,.2)";
var _6e = "#52c41a";
var _6f = "12px";
var _70 = "20px";
var _71 = "rgba(250,173,20,.2)";
var _72 = "#faad14";
var _73 = "#fff";
var _74 = "hsla(0,0%,100%,.2)";
export { _1 as "actionButtonColorDark", _2 as "actionButtonColorLight", _3 as "actionButtonColorMedium", _4 as "automatic-changes-proposed", _5 as "borderRadiusCard", _6 as "borderRadiusMain", _7 as "borderRadiusSurface", _8 as "boxShadowInnerXs", _9 as "boxShadowXl", _a as "btnRightMargin", _b as "cardBorderColor", _c as "cardPadding", _d as "changeSetCompletedColor", _e as "changeSetManuallyChangesProposed", _f as "changeSetScheduledChangesProposed", _10 as "chipBackground", _11 as "colorAccentAmber", _12 as "colorAccentBerry", _13 as "colorAccentBrown", _14 as "colorAccentCornflower", _15 as "colorAccentCyan", _16 as "colorAccentOlive", _17 as "colorAccentPurple", _18 as "colorAccentSteelBlue", _19 as "colorAccentTeal", _1a as "colorAccentTerracotta", _1b as "colorBackgroundMain", _1c as "colorBackgroundSidebar", _1d as "colorBackgroundSidebarHover", _1e as "colorBackgroundTabs", _1f as "colorBorderContainer", _20 as "colorBorderMain", _21 as "colorBorderSecondary", _22 as "colorDeltaCyanBlueBg", _23 as "colorDeltaGray", _24 as "colorDeltaGrayBg", _25 as "colorDeltaGreen", _26 as "colorDeltaGreenBg", _27 as "colorDeltaRed", _28 as "colorDeltaRedBg", _29 as "colorDetailsFieldText", _2a as "colorDetailsIcon", _2b as "colorDetailsTagBg", _2c as "colorMint", _2d as "colorMintGradient", _2e as "colorMintLight", _2f as "colorPrimary", _30 as "colorPrimaryHover", _31 as "colorPrimaryLightened", _32 as "colorTableHeadBg", _33 as "colorTableHeadBgHover", _34 as "colorTableHeadSubtitle", _35 as "colorTableRowBorder", _36 as "colorTableTextBg", _37 as "colorTableTotalRowBg", _38 as "colorTextBase", _39 as "colorTextDisabled", _3a as "colorTextExtraLight", _3b as "colorTextLight", _3c as "colorTextLighter", _3d as "colorTextMainHeading", _3e as "colorTextMuted", _3f as "colorTextPrimary", _40 as "contentHorizPadding", _41 as "dangerColor", _42 as "dashboardPdfContentWidth", _43 as "errorBackcolor", _44 as "errorColor", _45 as "failure", _46 as "filterPanelPadding", _47 as "filtersDefaultHeight", _48 as "filtersTallHeight", _49 as "fontSizeLarge", _4a as "fontSizeMain", _4b as "fontSizeMedium", _4c as "fontSizePlus", _4d as "fontSizeSmaller", _4e as "fontSizeSmallest", _4f as "fontSizeXLarge", _50 as "fontSizeXxLarge", _51 as "fontWeightBold", _52 as "fontWeightExtraLight", _53 as "fontWeightLight", _54 as "fontWeightMediumBold", _55 as "fontWeightNormal", _56 as "fontWeightSemiBold", _57 as "ghostWhite", _58 as "grayBackgroundColor", _59 as "headerHeight", _5a as "icon", _5b as "iconHorizontalMargin", _5c as "linkColor", _5d as "linkColorMuted", _5e as "neutral", _5f as "popoverHeaderColor", _60 as "popoverMaskColor", _61 as "rowPadding", _62 as "ruleInnerGutters", _63 as "ruleSideGutters", _64 as "sideMenuIconColor", _65 as "sideMenuIconSelectedColor", _66 as "sideMenuItemColor", _67 as "sideMenuScrollbarThumbColor", _68 as "sideMenuSubmenuItemColor", _69 as "sidebarCollapsedWidth", _6a as "sidebarWidth", _6b as "state-wrapper", _6c as "success", _6d as "successBackcolor", _6e as "successColor", _6f as "tableHeaderVerticalPadding", _70 as "tableHorizPadding", _71 as "warningBackcolor", _72 as "warningColor", _73 as "whiteColor", _74 as "whiteDividerColor" }
